module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-left-1.bf80f7b2.png";